import "../JQuery/jquery-ui.min"; // dialog
import "../../styles/old-error-dialog.less";
import { extend, isFunction } from "lodash";

(function ($, ep) {
    "use strict";

    var MessageManager = function () {

        this.messageQueue = [];

        this.resetMessageQueue = function () {
            this.messageQueue = [];
        };

        this.showOrEnqueueError = function (title, message) {
            this._showOrEnqueueMessage(ep.messageManagerTypes.error, { title: title, message: message });
        };

        this.showOrEnqueueConfirmation = function (title, message, saveText, cancelText, saveAction) {
            this._showOrEnqueueMessage(ep.messageManagerTypes.confirmation, { title: title, message: message, saveText:saveText, cancelText:cancelText, saveAction:saveAction });
        };

        this._showOrEnqueueMessage = function (messageType, options) {
            this.messageQueue.push({
                type: messageType,
                options: options
            });

            if (this.messageQueue.length == 1) {
                this._showFirstInQueue();
            }
        };

        this._dequeueFirst = function() {
            return this.messageQueue.shift();
        };

        this._showFirstInQueue = function() {
            if (!this.messageQueue.length)
                return;

            var messageItem = this.messageQueue[0];

            var onDialogClose = () => {
                this._dequeueFirst();
                this._showFirstInQueue();
            };

            this._showMessage(messageItem.type, messageItem.options, onDialogClose);
        };

        this._showMessage = function(messageType, options, onDialogClose) {
            switch (messageType) {
                case "error":
                    this.showError(options.title, options.message, onDialogClose);
                    break;
                case "confirmation":
                    this.showConfirmation(extend({}, options, {
                        onClose: onDialogClose
                    }));

                    break;
            }
        };

        this.showError = function (title, message, onClose, okBtnText = 'Ok') {
            var buttons = {
                [okBtnText]: function() {
                    $(this).dialog("close");
                }
            };
            this._showDialog("ep-ac-error-dialog", {
                title: title,
                message: message,
                buttons: buttons,
                onClose: onClose
            });
        };

        this.showErrorDeferred = function (title, message) {
            var d = $.Deferred();

            this.showError(title, message, function () {
                d.resolve();
            });

            return d.promise();
        };

        this.showConfirmationAsync = function(options){
            var promise = $.Deferred();

            options = extend(options, {
                saveAction: function(){
                    promise.resolve();
                },

                onClose : function(){
                    if(promise.state() === "pending"){
                        promise.reject();
                    }
                }
            });

            this.showConfirmation(options);
            return promise.promise();
        };

        this.showConfirmation = function (options) {
            var buttons = [
                {
                    text: options.saveText,
                    "class": options.saveBtnClass || ep.messageManagerButtons.positive,
                    click: function (event) {
                        var self = this;
                        var closeOnActionCompleted = false;
                        if (typeof options.saveAction == 'function') {
                            var result = options.saveAction();

                            if (result && result.always && isFunction(result.always)) {
                                $(event.target).closest("button").addClass("loading");
                                closeOnActionCompleted = true;
                                result.always(function () {
                                    $(self).dialog("close");
                                });
                            }
                        }

                        if (!closeOnActionCompleted) {
                            $(self).dialog("close");
                        }
                    }
                },
                {
                    text: options.cancelText || ep.resources.commonClient.Cancel,
                    click: function () {
                        $(this).dialog("close");
                    }
                }
            ];
            options.buttons = buttons;
            this._showDialog("ep-confirm-dialog", options);
        };

        this._showDialog = function (contentElementId, options) {
            options = $.extend({
                title: "",
                onClose: () => { this.resetMessageQueue(); }
            }, options);

            var dlgOptions = {
                title: options.title,
                buttons: options.buttons,
                close: options.onClose
            };

            var dialog = $("#" + contentElementId);
            if (!dialog.length) {
                dialog = $("<div id=\"" + contentElementId + "\"><div class=\"dialog-content\"></div></div>");
                dialog.dialog($.extend({
                    modal: true,
                    draggable: false,
                    resizable: false,
                    classes: {
                        /**
                         * The dialogClass option has been deprecated in favor of the classes option, using the ui-dialog property.
                         */
                        "ui-dialog": "ep-ac-error-dialog",
                    },
                    width: 600,
                }, dlgOptions));

                this._setMessage(dialog, options.message);
            }
            else {
                dialog.dialog("option", dlgOptions);
                this._setMessage(dialog, options.message);

                dialog.dialog("open");
            }
            this.dialog = dialog;
        };

        this._setMessage = function (dialog, message) {
            $(".dialog-content", dialog).html(message);
        };
    };

    ep.messageManager = new MessageManager();

    ep.messageManagerButtons = {
        aggressive: "aggressive-btn",
        positive: "positive-btn"
    };

    ep.messageManagerTypes = {
        error: "error",
        confirmation: "confirmation"
    };

})(jQuery, ep);
